import { useState } from "react";

import { useUserContext } from "../../context/User";
import { succeedAdoption } from "../../services/api";
import { getSendIcon } from "../../services/icons";
import Button from "../Button";

const AdoptOverview = ({ pet, adoption }) => {
  const [isSucceeded, setIsSucceeded] = useState(adoption.status === "succeeded");
  const { user } = useUserContext();

  const sendInquiryHandler = async () => {
    if (!user.accessToken) return;

    const result = await succeedAdoption(user.accessToken, adoption.id);
    if (result) {
      setIsSucceeded(true);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-6">
        <div className="max-w-xl">
          <div className="flex flex-col items-center gap-6 text-center">
            <div>
              You and {pet.name} are a match. 🐾
              <br />
              The next step is to contact <strong>{pet.user.profile.title}</strong> and let them
              know you’re interested in {pet.name}.
            </div>
            <div>
              <Button
                leftIcon={getSendIcon()}
                title={isSucceeded ? "Inquiry has been sent" : "Send adoption inquiry"}
                theme="dark"
                size="medium"
                disabled={isSucceeded}
                onClick={sendInquiryHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdoptOverview;
